import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Modal, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import OpeningTicketPurposePicker from '../../reference/components/OpeningTicketPurposePicker'
import {UpdateIdentifiedRequestsAction} from '../models'
import {UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED, sendUpdateIdentifiedRequestsAction, updateUpdateIdentifiedRequestsAction, loadWorkflowStream} from '../actions'
import i18n from '../i18n'

function openingTicketPurposeAggregator(reference) {
    return (result, openingTicketPurposeId) => {
        const openingTicketPurpose = reference.openingTicketPurposes.find((otp) => otp.uid == openingTicketPurposeId)

        if (openingTicketPurpose) {
            result.push(openingTicketPurpose)
        } else {
            console && console.warn('openingTicketPurpose "' + openingTicketPurposeId + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

class UpdateIdentifiedRequestsModal extends Component {
    static propTypes = {
        workflow: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, workflow, reference} = this.props

        const identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), [])
        dispatch(updateUpdateIdentifiedRequestsAction({identifiedRequests}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.workflow != this.props.workflow) {
            const {dispatch, workflow, reference} = nextProps

            const identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), [])
            dispatch(updateUpdateIdentifiedRequestsAction({identifiedRequests}))
        }
    }

    _sendAction() {
        const {dispatch, workflow, onHide} = this.props

        return dispatch(sendUpdateIdentifiedRequestsAction(workflow.uid)).then(() => {
            return dispatch(loadWorkflowStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, action, company, workflow, reference, onHide, ...others} = this.props

        return (
            <Modal
                bsSize='large'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.identifiedRequests}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OpeningTicketPurposePicker multi split
                        company={company}
                        {...form.identifiedRequests()} />
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendAction() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

UpdateIdentifiedRequestsModal = connectForm({
    target: 'action',
    schema: UpdateIdentifiedRequestsAction.schema,
    action: UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED
})(UpdateIdentifiedRequestsModal)

UpdateIdentifiedRequestsModal = connect((state) => ({
    reference: state.reference.openingTicketPurposeRef,
    company: state.company.company,
    action: state.workflow.updateIdentifiedRequestsAction
}))(UpdateIdentifiedRequestsModal)

export default UpdateIdentifiedRequestsModal


// WEBPACK FOOTER //
// ./lib/workflow/components/UpdateIdentifiedRequestsModal.js